import { MutableRefObject, useEffect, useRef, useState } from "react";

// copied from the react type definition
type SetNode = React.Dispatch<React.SetStateAction<HTMLElement | null>>;

export const useScrollVisible = (
  root: HTMLElement,
  rootMargin: string | undefined,
  threshold: number = 0,
): [HTMLElement | null, SetNode, boolean] => {
  const [visible, setVisible] = useState(false);
  const [node, setNode] = useState<HTMLElement | null>(null);
  const observer: MutableRefObject<IntersectionObserver | null> = useRef<IntersectionObserver>(
    null,
  );
  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new window.IntersectionObserver(
      ([innerEntry]) => {
        if (visible || !innerEntry.isIntersecting) {
          return;
        }
        setVisible(true);
      },
      {
        root,
        rootMargin,
        threshold,
      },
    );
    const { current: currentObserver } = observer;
    if (node) {
      currentObserver.observe(node);
    }
    return () => currentObserver.disconnect();
  }, [node, root]);
  return [node, setNode, visible];
};
